<template>
    <div class="FormContainerBlock">
        <div :id="'formContainer_' + model.contentLink.id"></div>
    </div>
</template>

<script>
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import ContentArea from '@/Scripts/components/ContentArea.vue';
import formRenderingService from '../../../../../../KoRus/Scripts/EPiServer.ContentApi.Forms/FormRenderingService';

export default
{
    props: ['model'],
    methods:
    {
        renderForm: function () {

            //console.log(formRenderingService);
            //console.log(this.model.formModel);
            console.log(this.model);

            var element = document.getElementById('formContainer_' + this.model.contentLink.id);
            formRenderingService.render(this.model.formModel, element);
        }
    },
    components:
    {
        EpiProperty,
        ContentArea
    },
    mounted() {
        this.renderForm();
    },
    updated: function () {
        this.renderForm();
    }
};
</script>
